export default "__VITE_ASSET__ChVCYvMp__"